export function isApplePlatform(platform: string | undefined): boolean {
  // Case-insensitive: Chromium's userAgentData says "macOS", Firefox's platform says "MacIntel".
  return /mac|iphone|ipad/i.test(platform ?? '');
}

/**
 * Whether to spell a modifier the Apple way (⌥) or the everywhere-else way
 * (Alt+). One definition, because the two shortcut badges in this bar — New
 * chat's and Build's — used to carry byte-identical hand copies of it, and a
 * hand-copied twin is exactly the thing this repo has been bitten by before:
 * the copies drift, nothing fails, and one badge starts lying on one platform.
 *
 * Evaluated once at module load, like the labels that read it: the platform a
 * browser is running on does not change mid-session.
 */
export const IS_APPLE =
  typeof navigator !== 'undefined' &&
  isApplePlatform(
    // userAgentData is the non-deprecated read; platform is the fallback.
    (navigator as { userAgentData?: { platform?: string } }).userAgentData?.platform ??
      navigator.platform,
  );
